<template>
  <div class="about">
      <div
          v-if="this.app.isBeta === true"
          class="alert alert-info"
          role="alert"
      >
          <h3 class="alert-heading h5">B&egrave;taversie</h3>
          <p>Je maakt gebruik van de b&egrave;taversie van de Groepsapp. Houd er rekening mee dat deze versie nog in ontwikkeling is en sommige onderdelen mogelijk niet volledig werken.</p>
          <hr>
          <p class="mb-0">
              <a class="alert-link" href="#" v-on:click="switchToStable()">Klik hier</a>
              om terug te schakelen naar de stabiele versie.
          </p>
      </div>
      <div
          v-else-if="this.app.isBeta === false && this.app.isBetaSwitchEnabled === true"
          class="alert alert-info"
          role="alert"
      >
          <h3 class="alert-heading h5">B&egrave;taversie beschikbaar</h3>
          <p>Je gebruikt momenteel de stabiele versie van de Groepsapp. Er is ook een b&egrave;taversie beschikbaar waarin nieuwe functies worden getest. Houd er rekening mee dat deze versie nog in ontwikkeling is en sommige onderdelen mogelijk niet volledig werken.</p>
          <hr>
          <p class="mb-0">
              <a class="alert-link" href="#" v-on:click="switchToBeta()">Klik hier</a>
              om over te schakelen naar de b&egrave;taversie.
          </p>
      </div>

    <h2>Over de app</h2>
    <table class="table table-light table-striped">
      <tbody>
      <tr>
        <td class="w-25">Uitgever</td>
        <td>{{ app.company_name }}</td>
      </tr>
      <tr>
        <td width="25%">Product</td>
        <td>{{ app.name }}</td>
      </tr>
      <tr>
        <td>Versie</td>
        <td>{{ app.tag }}</td>
      </tr>
      <tr>
        <td>Datastructuur versie</td>
        <td>{{ app.data_structure_version }}</td>
      </tr>
      <tr>
        <td>URL</td>
        <td>{{ url }}</td>
      </tr>
      <tr>
        <td>Sessie token</td>
        <td>{{ session.session_token }}</td>
      </tr>
      </tbody>
    </table>
    <h2>Over dit apparaat</h2>
    <table class="table table-light table-striped">
      <tbody>
      <tr>
        <td class="w-25">Datastructuur versie</td>
        <td>{{ dataStructureVersion }}</td>
      </tr>
      <tr>
        <td>User agent</td>
        <td>{{ userAgent }}</td>
      </tr>
      <tr>
        <td>Resolutie</td>
        <td>{{ resolution }}</td>
      </tr>
      <tr>
        <td>Local storage in gebruik</td>
        <td>{{ localStorageSizeUsed }} kb</td>
      </tr>
      <tr>
        <td>Local storage beschikbaar</td>
        <td>{{ localStorageSizeAvailable }} kb</td>
      </tr>
      </tbody>
    </table>
    <h2>Problemen verhelpen</h2>
    <table class="table table-light table-striped">
      <tbody>
      <tr>
        <td class="w-25">Soft reset app</td>
        <td>
          Verwijder alle (lokale) app data. Eerder opgeslagen gegevens zoals activiteiten, berichten, foto's en kindgegevens blijven uiteraard wel bewaard.
          <span class="text-info">U hoeft niet opnieuw in te loggen. </span>
          <a href="#" v-on:click="softResetApp()">Reset app</a>
        </td>
      </tr>
      <tr>
        <td>Hard reset app</td>
        <td>
          Verwijder alle (lokale) app data. Eerder opgeslagen gegevens zoals activiteiten, berichten, foto's en kindgegevens blijven uiteraard wel bewaard.
          <span class="text-danger">U dient hierna wel opnieuw in te loggen. </span>
          <a href="#" v-on:click="resetApp()">Reset app</a>
        </td>
      </tr>
      </tbody>
    </table>
    <h2>Ondersteuning</h2>
    <table class="table table-light table-striped">
      <tbody>
      <tr>
        <td class="w-25">Handig om te vermelden</td>
        <td>U maakt gebruik van de <b>{{ app.name }} {{ app.tag }}</b>
        </td>
      </tr>
      <tr>
        <td>Telefonische ondersteuning</td>
          <td>088 990 4444 <small>(helpdesk Kidsadmin)</small></td>
      </tr>
      <tr>
        <td>E-mail ondersteuning</td>
        <td>
            <a href="mailto:helpdesk@novict.com">helpdesk@novict.com</a> <small>(helpdesk Kidsadmin)</small>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'about',
  created () {
    this.$store.dispatch('loadApplicationSettings')
    this.$store.dispatch('loadAuthProfile')
    this.url = window.location.href
    this.userAgent = navigator.userAgent
    this.localStorageSizeUsed = this.getLocalStorageSizeUsed()
    this.localStorageSizeAvailable = this.getLocalStorageSizeAvailable()
    this.resolution = window.screen.width + ' x ' + window.screen.height
    this.dataStructureVersion = this.$store.getters.dataStructureVersion
  },
  data () {
    return {
      url: null,
      userAgent: null,
      localStorageSizeUsed: 0,
      localStorageSizeAvailable: 0,
      resolution: null,
      dataStructureVersion: null
    }
  }
}
</script>

<style scoped>
    pre {
        background: #f3f3f3;
        padding: 20px;
        padding-bottom: 0;
        border: 1px solid #cecece;
    }
</style>
